<template>
    <div class="pr-4 py-4 border-b border-gray-200">
        <p class="text-sm mb-1"><strong>{{ note.author.email }}</strong> ({{ createdDate }}) <TrashIcon class="ml-2 inline h-4 w-4 text-red-500 cursor-pointer" @click="deleteNote" /></p>
        <div class="prose">{{ note.content }}</div>
    </div>
</template>

<script>
    import moment from "moment/moment";
    import {TrashIcon} from "@heroicons/vue/24/outline";

    export default {
        name: 'NoteEntry',
        components: {
            TrashIcon,
        },
        props: {
            note: {
                type: Object,
                required: true,
            },
            account: {
                required: false,
                default: null,
            }
        },
        methods: {
            deleteNote() {
                if (!confirm('Are you sure?')) {
                    return
                }

                let accountId = this.account ?? this.$route.params.accountId

                axios.delete(route('accounts.notes.delete', { account: accountId, note: this.note.id }))
                    .then(response => {
                        this.$emit('deleted', this.note)
                    })
            },
        },
        computed: {
            createdDate() {
                return moment(this.note.created_at).format('DD/MM/YYYY HH:mm')
            }
        }
    }
</script>
